// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"4b48427a","113":"a959eb82","158":"db231600","164":"3b3cf705","354":"6c2461fb","481":"70d8ee0b","488":"f1dc7667","721":"19d9767f","941":"efdc8f27","946":"46ba2302","949":"efa8e31a","978":"3ccf2bfd"}[chunkId] + ".chunk.js";
};